import * as model from "@/model/prd/productionExecution/smelting/SmeltingProductionResult";
import { newEntityStoreHelper } from "@/store/common/entityModule";

import router from "@/router/index";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.SmeltingProductionResult(), newFilter)
    .withStates({
        idReport: 2,

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start    
    .withActions({  
        jumpToSmeltEnergyCost(context, entity) {
            router.push("/prd/smeltingEnergyCost");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/smeltingEnergyCost/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    //调试语句，用console
                    //console.log(response.list);
                    context.commit('smeltingEnergyCost' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        jumpToSmeltMatCost(context, entity) {
            router.push("/prd/smeltingMaterialCost");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/smeltingMaterialCost/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('smeltingMaterialCost' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        jumpToSmeltProductInfo(context, entity) {
            router.push("/prd/smeltingProductInfo");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/smeltingProductInfo/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {                    
                    context.commit('smeltingProductInfo' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        jumpToSmeltProductQuality(context, entity) {
            router.push("/prd/smeltingProductionQuality");
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/smeltingProductionQuality/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('smeltingProductionQuality' + "/setRows", response.list, { root: true });                                    
                }       
            }); 
            // router.push("/prd/smeltingProductQuality");                       
            // context.dispatch("api/get", {
            //     url: context.state.baseModuleUrl + "/smeltingProductQuality/findByPlanCode/" + entity.planCode
            // },{ root: true })
            // .then(response => {
            //     //seting the values
            //     {
            //         context.commit('smeltingProductQuality' + "/setRows", response.list, { root: true });                                    
            //     }       
            // });       
        },

        jumpToSmeltEquipPara(context, entity) {
            router.push("/prd/smeltingEquipPara");                       
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/smeltingEquipPara/findByPlanCode/" + entity.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('smeltingEquipPara' + "/setRows", response.list, { root: true });                                    
                }       
            });       
        },

        updateData(context, row){
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/smeltingProductionResult/updateData/" + row.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('smeltingProductionResult' + "/setRows", [response], { root: true });                                    
                }       
            });
        }
    })
    .buildStore()